import Papa from 'papaparse';
import type { Data, DataItem } from '../types';
import { appState } from './AppState';

export default class DataManager {
	constructor() {}

	init() {
		Papa.parse('/data.csv', {
			header: true,
			download: true,
			complete: (result) => {
				if (result.data) this.processData(result.data as { [key: string]: string }[]);
			}
		});

		console.log('DataManager init');
	}

	processData(data: { [key: string]: string }[]): void {
		const processedData: Data = {};
		for (const line of data) {
			const id = parseInt(line.id) || -1;
			const element = {
				id,
				name: line.name || undefined,
				theme: line.theme || undefined,
				programme: line.programme || undefined,
				title_hu: line.title_hu || undefined,
				title_en: line.title_en || undefined,
				concept_hu: line.concept_hu || undefined,
				concept_en: line.concept_en || undefined,
				material_hu: line.material_hu || undefined,
				material_en: line.material_en || undefined,
				url: line.url || undefined
			};
			processedData[id] = element as DataItem;
		}
		appState.setState({ data: processedData });
	}
}
